export class MockMatChip {
  get selected() { return true; }
}
